<template>
  <t-default-layout active-nav-id="campaigns-category">
    <div :class="componentClassName">
      <a-back-page text="一覧画面" page="CampaignsCategory" />
      <form
        ref="form"
        class="t-campaigns-category-add__form"
        enctype="multipart/form-data"
        @submit.prevent="handleFormSubmit"
      >
        <div class="t-campaigns-category-add__fields">
          <m-section>
            <m-action-card :id="idName[1]" title="カテゴリ設定" header-border no-header-margin icon="calendar-setting">
              <div class="t-campaigns-category-add__fields">
                <div id="t-campaigns-category-add-show-start-date-day__row" class="t-campaigns-category-add__row">
                  <a-text id="t-campaigns-category-add-show-start-date__a-text">カテゴリ名</a-text>　
                  <m-form-input id="t-campaigns-category-add-show-start-date-day__form-input">
                    <a-apply-text-field
                      id="t-campaigns-category-add-info-name"
                      v-model="categoryData.categoryName"
                      data-testid="add-campaigns-category-name-input"
                      type="text"
                      maxlength="5"
                      placeholder="カテゴリ名入力"
                    />
                  </m-form-input>
                </div>
              </div>
            </m-action-card>
          </m-section>
        </div>
        <m-form-action-buttons>
          <a-button
            id="saveBtn"
            data-testid="campaigns-category-save-button"
            variant="block"
            color="primary"
            :disabled="disabledButton"
            submit="submit"
            >追加</a-button
          >
        </m-form-action-buttons>
      </form>
    </div>
    <!-- Info, Erro Modal -->
    <teleport to="body">
      <o-modal
        id="campaignsCategoryCreate_resultModal"
        :visible="resultModalVisible"
        class="o-modal--confirmation"
        footer-variant="confirmation"
        width="442px"
        :footer-shadow="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
      >
        <template #title>{{ resultModalTitle }}</template>
        <a-text>
          <!-- eslint-disable -->
          <span id="campaignsCategoryCreate_resultModal_body" v-html="resultModalContent" />
          <!-- eslint-enable -->
        </a-text>
        <template #footer>
          <a-button
            data-testid="error-info-modal-confirm-button"
            variant="block"
            color="primary"
            label="OK"
            size="small"
            @click="handleCloseModal"
          />
        </template>
      </o-modal>
    </teleport>
  </t-default-layout>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import AButton from '@/components/atoms/button';
import AText from '@/components/atoms/text';
import ABackPage from '@/components/atoms/back-page';
import MSection from '@/components/molecules/section';
import AApplyTextField from '@/components/atoms/apply-text-field';
import MActionCard from '@/components/molecules/action-card';
import MFormActionButtons from '@/components/molecules/form-action-buttons';
import TDefaultLayout from '@/components/templates/default-layout';
import { customRequest } from '@/common/customRequest.js';
import { messageContent } from '@/common/messageContent.js';
import { customValidate } from '@/common/customValidate.js';
import { utils } from '@/common/utils.js';
import { useVuelidate } from '@vuelidate/core';
import { campaignsCategoryValidation } from '@/validations/campaignsCategory.js';
import { cloneDeep } from 'lodash';
export default {
  name: 't-campaigns-category-add',
  components: {
    TDefaultLayout,
    MSection,
    MActionCard,
    AText,
    AButton,
    AApplyTextField,
    ABackPage,
    MFormActionButtons,
  },
  mixins: [customRequest, customValidate, messageContent, utils],
  props: {
    class: {
      type: String,
      default: '',
    },
  },
  setup() {
    return {
      v$: useVuelidate(),
    };
  },
  data() {
    return {
      idName: [],
      minDate: utils.currentDateTime(),
      resultModalTitle: '',
      resultModalContent: '',
      resultModalVisible: false,
      disabledButton: null,

      // カテゴリデータ
      categoryData: {
        categoryName: '', // カテゴリ名
        createUserName: '' ,
        sortOrder: 0, // 位置のカテゴリ
        createdAt: '', // 作成の日時
      },
    };
  },
  validations() {
    return campaignsCategoryValidation;
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-campaigns-category-add');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  created() {
    const authInfo = this.$store.state.user.authInfo;
    // 「マネージャー」でない場合は「PermissionDenied」ページにリダイレクトする。
    if (authInfo !== 'manager') {
      this.$router.push({ name: 'PermissionDenied' });
      return;
    }
  },
  methods: {
    async handleFormSubmit() {
      const isFormCorrect = await this.v$.$validate();

      if (!isFormCorrect) {
        let errMsg = '';
        this.v$.$errors.map(item => (errMsg += item.$message + '<br>'));
        this.showErrorModal(errMsg);
        return;
      }

      const payload = cloneDeep(this.categoryData);

      if (!messageContent.checkHasSpecialCharacterInObj(payload)) {
        this.showErrorModal(messageContent.hasSpecialCharacter);
        return;
      }

      let maxSortOrder = 0;
      try {
        const data = { execUserID: this.execUserID };
        const response = await this.postRequest('/campaigns-category/get-list', data);
        if (response.status === 'success' && response.data && typeof response.data === 'object') {
          const categories = Object.keys(response.data).map(k => ({
            documentID: k,
            categoryName: response.data[k].categoryName,
            createUserName: response.data[k].createUserName,
            sortOrder: response.data[k].sortOrder || 0,
          }));
          maxSortOrder = categories.reduce((max, category) => {
            return Math.max(max, category.sortOrder);
          }, 0);
        }
      } catch (error) {
        this.showErrorModal('カテゴリリストの取得中にエラーが発生しました: ' + error.message);
        return;
      }
      const newSortOrder = maxSortOrder + 1;
      const formDataTmp = {
        categoryName: this.categoryData.categoryName ?? '',
        sortOrder: newSortOrder,
      };
      this.disabledButton = 'disabled';
      await this.postRequest('/campaigns-category/add', formDataTmp).then(res => {
        if (res.status === 'success') {
          this.$router.push({ name: 'CampaignsCategory' });
        } else {
          if (res.message) {
            this.showErrorModal(res.message);
          } else {
            this.showErrorModal(messageContent.requireTry('記事・セミナー（カテゴリ）作成'));
          }
        }
        this.disabledButton = null;
      });
    },
    handleCancelClick() {
      this.$router.push({ name: 'CampaignsCategory' });
    },
    handleCloseModal() {
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
    },
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
    },
    showInfoModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.infoModalTitle;
      this.resultModalContent = message;
    },
  },
};
</script>
